import script from "./Menu.vue?vue&type=script&lang=tsx"
export * from "./Menu.vue?vue&type=script&lang=tsx"

import "./Menu.vue?vue&type=style&index=0&id=3e61b6c3&lang=scss&scoped=true"
script.__scopeId = "data-v-3e61b6c3"

export default script